module.exports = {
  created () {
    this.$_notificationsToCloseOnDestroy = [] // eslint-disable-line camelcase
  },
  beforeDestroy () {
    this.$_notificationsToCloseOnDestroy.forEach(noty => noty.close())
  }
}



// WEBPACK FOOTER //
// ./src/helpers/noty.js